import { IWidget } from '@/pages/Dashboards/dashboards.types.ts'
import Button from '@/shared/Buttons/Button'
import CreateLineChartSettingsContent from '@/pages/Dashboards/components/CreateWidgetSidePage/CreateWidgetSettingsContent/CreateLineChartSettingsContent'
import { useState } from 'react'
import CreateSvgChartSidePageContent from '@/pages/Dashboards/Charts/SVGChart/SvgChartSettingsSidePage/CreateSvgChartSidePageContent'
import CreateTextChartSettingsContent from '@/pages/Dashboards/components/CreateWidgetSidePage/CreateWidgetSettingsContent/CreateTextSettingContent'
import CreateTableChartSettingsContent from '@/pages/Dashboards/components/CreateWidgetSidePage/CreateWidgetSettingsContent/CreateTableChartSettingsContent'

interface IProps {
  widgetType: IWidget['type']
  onSave: (settings: IWidget['configuration']['settings']) => void
  onCancel: () => void
  loading: boolean
}

const CreateWidgetSettingsContent = (props: IProps) => {
  const [settings, setSettings] = useState<IWidget['configuration']['settings']>(null)
  const [svgStep, setSvgStep] = useState<'common-info' | 'settings'>('common-info')

  const renderForm = () => {
    switch (props.widgetType) {
      case 'linear':
        return <CreateLineChartSettingsContent onChange={setSettings} />
      case 'svg':
        return <CreateSvgChartSidePageContent setSettings={setSettings} step={svgStep} />
      case 'text':
        return <CreateTextChartSettingsContent onChange={setSettings} />
      case 'table':
        return <CreateTableChartSettingsContent onChange={setSettings} />
    }
  }

  const getSubmitButtonText = () => {
    if (props.widgetType === 'svg') {
      return svgStep === 'common-info' ? 'Далее' : 'Сохранить'
    }

    return 'Сохранить'
  }

  const handleSubmitButtonClick = () => {
    if (svgStep === 'common-info') {
      setSvgStep('settings')
    } else {
      props.onSave(settings)
    }
  }

  return (
    <div className="flex-lines height100">
      {renderForm()}
      <div
        className="inline-flex-gap"
        style={{ marginTop: 'auto', paddingTop: '16px', borderTop: '1px solid var(--border-secondary-color)' }}
      >
        <Button size="default" type="default" text="Отмена" disabled={props.loading} onClick={props.onCancel} />
        <Button
          size="default"
          type="primary"
          text={getSubmitButtonText()}
          onClick={handleSubmitButtonClick}
          loading={props.loading}
        />
      </div>
    </div>
  )
}

export default CreateWidgetSettingsContent
